export const projectAscSort = (clientData) => {
  var sortedData = clientData.sort((a, b) => {
    if (!a.projects || !b.projects) {
      return -1
    }

    return a.projects.length > b.projects.length ? 1 : -1
  })

  return sortedData
}

export const projectDscSort = (clientData) => {
  var sortedData = clientData.sort((a, b) => {
    if (!a.projects || !b.projects) {
      return 1
    }

    return a.projects.length < b.projects.length ? 1 : -1
  })

  return sortedData
}

export const projectAphaSort = (clientData) => {
  var sortedData = clientData.sort((a, b) => (a.title > b.title ? 1 : -1))

  return sortedData
}
